<template>
  <div>
    <span
      @click="create"
      data-cy="community-edit-button"
      class="create-button"
    >{{ $t('community.editCommunityButton.editCommunity') }}</span>
    <modal
      v-if="showModal"
      @close="closeModal"
      class="create-community-modal"
      :height="'590px'"
      :overflow-y="'hidden'"
    >
      <div slot="header">
        {{ $t('community.editCommunityButton.editCommunity') }}
      </div>
      <edit-community-modal
        slot="body"
        :on-close="closeModal"
        :community="community"
      />
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/shared/Modal'
import EditCommunityModal from '@/components/community/EditCommunityModal'

export default {
  name: 'EditCommunityButton',
  components: { EditCommunityModal, Modal },
  props: {
    community: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
    },
    create () {
      this.showModal = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-community-modal {
    color: $black-color;
}
</style>
